var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 4.5L30.51 4.545L22.5 7.65L13.5 4.5L5.04 7.35C4.725 7.455 4.5 7.725 4.5 8.07V30.75C4.5 31.17 4.83 31.5 5.25 31.5L5.49 31.455L13.5 28.35L22.5 31.5L30.96 28.65C31.275 28.545 31.5 28.275 31.5 27.93V5.25C31.5 4.83 31.17 4.5 30.75 4.5ZM15 8.205L21 10.305V27.795L15 25.695V8.205ZM7.5 9.69L12 8.175V25.725L7.5 27.465V9.69ZM28.5 26.31L24 27.825V10.29L28.5 8.55V26.31Z",
    fill: "#376EB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.3169007ce49eca3ac74c3c061fb94bb6.svg";
export { ForwardRef as ReactComponent };